import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import {
	AccountInfo,
	AuthenticationResult,
	IPublicClientApplication,
	InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { Method } from "axios";
import httpService from "../services/httpService";
import { api_s2 } from "../config";

export type ApiMethod = Method;

export const callPymbleApi = async (
	instance: IPublicClientApplication,
	method: Method,
	url: string,
	options: Record<string, unknown> | null = null
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
	await instance.initialize();

	let account: AccountInfo | null = null;

	try {
		const accounts = instance.getAllAccounts();
		account = accounts[0] || null;
	} catch (error) {
		console.error("callPymbleApi - Error getAllAccounts", error);
		return Promise.reject(error);
	}

	if (!account) return null;

	let response: AuthenticationResult | void;
	try {
		response = await instance.acquireTokenSilent({
			scopes: api_s2.scopes,
			account,
		});
	} catch (error) {
		if (error instanceof InteractionRequiredAuthError) {
			await instance.acquireTokenRedirect({
				scopes: api_s2.scopes,
				account,
			});
			return null;
		}
		console.error("acquireTokenSilent failed:", (error as Error).message);
		return null;
	}

	if (!response?.accessToken) {
		return Promise.reject("No access token found");
	}

	const res = await httpService.request({
		method,
		url,
		...options,
		headers: {
			Authorization: `Bearer ${response.accessToken}`,
			...(options?.headers as Record<string, string> | undefined),
		},
	});

	return res?.data ?? null;
};

export function usePymbleApi() {
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();

	const callApi = async (
		method: Method,
		url: string,
		options: Record<string, unknown> | null = null
	) => {
		return callPymbleApi(instance, method, url, options);
	};

	return { instance, callApi, isAuthenticated };
}
